import { EntityActions, UsersActions } from '../actions/consts';

type UsersUIState = {
  loading: boolean;
  errorMessage: string;
  successMessage: string;
  currentList: [];
  currentPage: number;
}

type UsersState = {
  entities: {};
  ui: UsersUIState;
}

export function users(
  state = { entities: {}, ui: { currentList: [], errorMessage: '', loading: false } } as UsersState, action
) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.users,
        }
      };
    case UsersActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
          successMessage: '',
        }
      };
    case UsersActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case UsersActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case UsersActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case UsersActions.RESET_SUCCESS_MESSAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          successMessage: '',
        }
      };
    case UsersActions.SAVE_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
          successMessage: '',
        }
      };
    case UsersActions.CREATE_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          successMessage: 'The user was successfully created.',
          errorMessage: '',
        }
      };
    case UsersActions.SAVE_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          successMessage: 'The user was successfully updated.',
          errorMessage: '',
        }
      };
    case UsersActions.SAVE_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
   case UsersActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
